import { Divider } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import * as React from 'react';

import type { ProductOffer } from 'v2/interfaces/product';

import { LinksModal } from './LinksModal';
import { List } from './List';
import { useStyles } from './styles';

import type IProduct from 'interfaces/IProduct';

type OffersProps = {
  isAffiliate: boolean;
  product: IProduct;
};

export function Offers({ isAffiliate, product }: OffersProps) {
  const classes = useStyles();
  const [offer, setOffer] = React.useState<ProductOffer | undefined>(undefined);
  const [isLinksModalOpen, setIsLinksModalOpen] = React.useState(false);

  const handleLinksClick = React.useCallback((offer: ProductOffer) => {
    setOffer(offer);
    setIsLinksModalOpen(true);
  }, []);

  return (
    <Card className={classes.card}>
      <h3 className={classes.title}>Ofertas</h3>
      <Divider />
      <CardContent className={classes.cardContent}>
        <List isAffiliate={isAffiliate} productId={product.id} handleLinksClick={handleLinksClick} />
      </CardContent>
      {offer && <LinksModal isAffiliate={isAffiliate} isOpen={isLinksModalOpen} closeModal={() => setIsLinksModalOpen(false)} offer={offer} />}
    </Card>
  );
}
